import { render, staticRenderFns } from "./editorBlock.vue?vue&type=template&id=a1fd7ea4&scoped=true&"
import script from "./editorBlock.vue?vue&type=script&lang=js&"
export * from "./editorBlock.vue?vue&type=script&lang=js&"
import style0 from "./editorBlock.vue?vue&type=style&index=0&id=a1fd7ea4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1fd7ea4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCol,VDivider,VExpandXTransition,VHover,VIcon,VRow,VSheet})
